import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { SafeImage } from "./SafeImage";
import { HeartDivider } from "./Ornaments";
import { scrollToId } from "./scroll";

const tornPath = (base, amp, seed) => {
  let d = `M0 80 L0 ${base}`;
  for (let x = 0; x <= 1440; x += 10) {
    const y = base + Math.sin(x * 0.011 + seed) * amp + Math.sin(x * 0.047 + seed * 2) * (amp / 2.5) + (((x * 7919 + seed * 31) % 11) - 5) * 0.45;
    d += ` L${x} ${y.toFixed(1)}`;
  }
  return `${d} L1440 80 Z`;
};
const TORN_BACK = tornPath(30, 7, 1);
const TORN_FRONT = tornPath(38, 6, 4);

export const Hero = () => {
  const { t } = useLang();
  return (
    <section id="hem" className="hero" data-testid="section-hem">
      <picture className="hero__bg">
        <source type="image/webp" srcSet="/images/hero/hero-meadow-1000.webp 1000w, /images/hero/hero-meadow.webp 2000w" sizes="100vw" />
        <SafeImage src="/images/hero/hero-meadow.jpg" alt={t.hero.alt} fetchPriority="high" width="2000" height="1342" testId="hero-image" />
      </picture>
      <div className="hero__glow" aria-hidden="true" />
      <div className="hero__cottage-label-row">
        <div className="hero__cottage-label hero__cottage-label--karlstugan">
          <a href="/stugor/karlstugan" aria-label={`${t.cottagePage.viewCottage}: Karlstugan Cottage`}>
            <span className="hero__cottage-kicker">{t.cottages.cottageNo} 01</span>
            <span className="hero__cottage-name">Karlstugan Cottage</span>
            <span className="hero__cottage-action">{t.cottagePage.viewCottage} <ArrowRight size={14} strokeWidth={1.5} aria-hidden="true" /></span>
          </a>
        </div>
        <div className="hero__cottage-label hero__cottage-label--bjorkslingan">
          <a href="/stugor/bjorkslingan" aria-label={`${t.cottagePage.viewCottage}: Björkslingan`}>
            <span className="hero__cottage-kicker">{t.cottages.cottageNo} 02</span>
            <span className="hero__cottage-name">Björkslingan</span>
            <span className="hero__cottage-action">{t.cottagePage.viewCottage} <ArrowRight size={14} strokeWidth={1.5} aria-hidden="true" /></span>
          </a>
        </div>
      </div>
      <div className="hero__content">
        <h1 className="hero__title hero-in" data-testid="hero-title">
          <span className="script hero__pre">{t.hero.pre}</span> <span className="hero__name">Vimmerbyferie</span>
        </h1>
        <p className="hero__eyebrow hero-in hero-in--2" data-testid="hero-eyebrow">{t.hero.eyebrow}</p>
        <HeartDivider className="hero__heart hero-in hero-in--2" />
        <p className="hero__line hero-in hero-in--3" data-testid="hero-line">{t.hero.line}</p>
        <div className="hero__actions">
          <button type="button" className="btn btn--primary btn--hero" onClick={() => scrollToId("stugor")} data-testid="hero-cta-button">
            {t.hero.cta}
            <ArrowRight size={18} strokeWidth={1.6} aria-hidden="true" />
          </button>
          <button type="button" className="btn btn--text" onClick={() => scrollToId("kontakt")} data-testid="hero-contact-link">
            {t.hero.secondary}
          </button>
        </div>
      </div>
      <svg className="hero__torn" viewBox="0 0 1440 80" preserveAspectRatio="none" aria-hidden="true">
        <path d={TORN_BACK} fill="#efe8da" />
        <path d={TORN_FRONT} fill="var(--ivory)" />
      </svg>
    </section>
  );
};
